module.exports = __webpack_public_path__ + "img/invite_bg.44e67937.png";